// extracted by mini-css-extract-plugin
export default {"content":"Terms_content__k7pW1"};